import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	objectionCategoryChip: {
		backgroundColor: themeColors.colors.system.beige[100],
		color: themeColors.colors.system.beige[800],
		borderRadius: "999px",
		fontSize: "0.75rem",
		fontWeight: 600,
		height: "24px"
	},
	objectionSummary: {
		fontSize: "0.9375rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	},
	conversionSubtitle: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	conversionLabel: {
		fontSize: "0.75rem",
		fontWeight: 700,
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	}
}))

export default useStyles
